import React, { useEffect } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router";
import RowClientOffice from "../row-client-office/row-client-office";
import { useDispatch, useSelector } from "react-redux";
import { checkToken, doInitClient } from "../../../store/actions/auth";
import LoginClient from "../hoc/login-client";
import ErrorBoundry from "../../../components/error-boundry";
import ErrorServer from "../../../components/errorServer/error-server";
import { compose } from "redux";
import withApiService from "../../../components/hoc/with-api-service";
import MainPage from "../pages/main-page/main-page";
import ChildClient from "../pages/child-client/child-client";
import { PrivateRouteClient } from "../hoc/private-route-client";
import SettingsClient from "../pages/settings-client/settings-client";
import PasswordClient from "../pages/settings-client/password-client";
import TrainingClient from "../pages/training-client/training-client";
import InvoiceClient from "../pages/invoice-client/invoice-client";
import FinanceClient from "../pages/finance-client/finance-client";
import MessagesClient from "../pages/messages-client/message-client";
import StrahovanieClient from "../pages/strhovanie/strhovanie"

const App = (props) => {
  const { history } = props;
  const dispatch = useDispatch();
  const authenticated = useSelector((state) => state.auth.authenticated);
  const errorMessage = useSelector((state) => state.admin.errorMessage);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      history.push("/client/login");
    }
    dispatch(checkToken(doInitClient));
  }, [dispatch, history]);

  if (!authenticated) {
    return (
      <Switch>
        <Route exact path="/client/login" component={LoginClient} />
      </Switch>
    );
  }

  return (
    <RowClientOffice>
      <Switch>
        <ErrorBoundry>
          <Redirect to="/client" />
          <PrivateRouteClient
            authed={authenticated}
            exact
            path={"/"}
            component={() => <Redirect to={"/client"} />}
          />
          <PrivateRouteClient
            exact
            path="/client"
            component={MainPage}
            authed={authenticated}
          />
          <PrivateRouteClient
            exact
            path="/client/child/:id"
            authed={authenticated}
            component={({ match }) => {
              const { id } = match.params;
              return <ChildClient id={id} />;
            }}
          />
          <PrivateRouteClient
            exact
            path="/client/training/:id"
            authed={authenticated}
            component={TrainingClient}
          />
          <PrivateRouteClient
            exact
            path="/client/invoice/:id"
            authed={authenticated}
            component={InvoiceClient}
          />
          <PrivateRouteClient
            exact
            path="/client/messages"
            component={MessagesClient}
            authed={authenticated}
          />
          <PrivateRouteClient
            exact
            path="/client/strhovanie"
            component={StrahovanieClient}
            authed={authenticated}
          />
          <PrivateRouteClient
            exact
            path="/client/finance"
            component={FinanceClient}
            authed={authenticated}
          />
          <PrivateRouteClient
            exact
            path="/client/settings"
            component={SettingsClient}
            authed={authenticated}
          />
          <PrivateRouteClient
            exact
            path="/client/settings/password"
            component={PasswordClient}
            authed={authenticated}
          />
          {errorMessage ? <ErrorServer error={errorMessage} /> : null}
        </ErrorBoundry>
      </Switch>
    </RowClientOffice>
  );
};

export default compose(withApiService())(withRouter(App));
